module.exports = __webpack_public_path__ + "img/collection-weddingRingsPlain@2x.971cc6d.webp";